import { Directive, AfterContentInit, OnDestroy, Optional, ContentChildren, QueryList } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Directive({
    // Direct element selector targets EVERY <mat-select> in the app
    selector: 'mat-select',
    standalone: true
})
export class AutoSelectSingleGlobalDirective implements AfterContentInit, OnDestroy {
    @ContentChildren(MatOption, { descendants: true }) options!: QueryList<MatOption>;
    private subscription = new Subscription();

    constructor(
        @Optional() private ngControl: NgControl,
        @Optional() private matSelect: MatSelect
    ) { }

    ngAfterContentInit(): void {
        if (!this.matSelect) return;

        // Trigger whenever options are added/loaded dynamically
        this.subscription.add(
            this.options.changes.pipe(startWith(this.options)).subscribe((optionsList: QueryList<MatOption>) => {
                this.evaluateAndSelect(optionsList.toArray());
            })
        );
    }

    private evaluateAndSelect(optionItems: MatOption[]): void {
        if (optionItems && optionItems.length === 1) {
            const singleOption = optionItems[0];
            const targetValue = singleOption.value;

            if (targetValue === undefined || targetValue === null || this.matSelect.value === targetValue) {
                return;
            }

            queueMicrotask(() => {
                // 1. Update Reactive Forms / ngModel
                if (this.ngControl && this.ngControl.control) {
                    if (this.ngControl.value !== targetValue) {
                        this.ngControl.control.setValue(targetValue);
                        this.ngControl.control.markAsDirty();
                        this.ngControl.control.markAsTouched();
                    }
                } else {
                    this.matSelect.value = targetValue;
                }

                // 2. Emit selectionChange event so template listeners like (selectionChange)="onSelect()" trigger
                this.matSelect.selectionChange.emit({
                    source: this.matSelect,
                    value: targetValue
                });
            });
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}